import { render } from "./Step2Plan.vue?vue&type=template&id=2c9d390c"
import script from "./Step2Plan.vue?vue&type=script&lang=js"
export * from "./Step2Plan.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__